<template>
  <div>
    <input type="text" className="form-control" placeholder="" v-model="propsValue">

    <PatientList :dep="dep"></PatientList>
  </div>
</template>

<script>/**

 **/
import PatientList from "@/views/rcc/component/PatientList.vue";


export default {
  components: {PatientList},
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data: function () {
    return {
      id: "",
      dataReady: false,
      propsValue: this.value,
      formData: {
        name: "",
      },
      dep:"",
    };
  },
  watch: {
    propsValue(newVal) {
      //this.('input', newVal);
      this.$emit('input', newVal);
    },
    value(newVal) {
      this.propsValue = newVal
    }
  },
  methods: {
    //給予value屬性預設值
    initValue() {
      const isMyObjectEmpty = !Object.keys(this.value).length;

      if (isMyObjectEmpty) {
        let template = {...this.datasDemo};
        this.value = template;
      }
    },
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
  },
  mounted() {
    // this.initValue()
    //this.loadData()
    this.dep=this.$route.query.dep
  },
}
</script>

<style scoped>

</style>
